import { Test } from "oc-e2e-testrunner";
import { assertKeineLückeZwischenPfostenUndElementen, resetArrangement } from "./utils";

export default {
  name: "TestRechteckSchwellwert",
};

export const testElementSchließtMitPfostenAb: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 1.5;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[1];
  const parts = s.getPartsAndPfosten();
  const element = s.getElemente()[0];
  element.setKonfigurierbareBreite(1.29);
  agt.update3d();
  assertKeineLückeZwischenPfostenUndElementen(s);
};
